import { Navigate, useLocation } from 'react-router-dom';
import type { ReactNode } from 'react';

import { useAuth } from '@/contexts/AuthContext';

/**
 * Componente que protege rotas — exige usuário autenticado.
 *
 * Se não autenticado, redireciona pra /login preservando a URL de origem
 * em `state.from` (pra voltar pra ela depois do login).
 */
export function RequireAuth({ children }: { children: ReactNode }) {
  const { isAuthenticated, loading, user } = useAuth();
  const location = useLocation();
  const noAplicativoDoTecnico = location.pathname === '/campo' || location.pathname.startsWith('/campo/');

  // Enquanto restaura sessão do localStorage, mostra nada
  if (loading) {
    return (
      <div className="min-h-screen bg-paper dark:bg-paper-dark flex items-center justify-center">
        <div className="text-ink-3 dark:text-ink-dark-3 text-sm">Carregando...</div>
      </div>
    );
  }

  if (!isAuthenticated) {
    // O aplicativo do técnico tem a entrada própria (e-mail e senha, 25/10/2026); o resto vai ao login do Google.
    return <Navigate to={noAplicativoDoTecnico ? '/campo/entrar' : '/login'} state={{ from: location }} replace />;
  }

  // O técnico que entrou com e-mail e senha só abre o aplicativo do técnico — o servidor barra o resto; aqui ele nem
  // chega a ver uma tela do escritório respondendo "sem acesso".
  if (user?.tipo === 'tecnico' && !noAplicativoDoTecnico) {
    return <Navigate to="/campo" replace />;
  }

  return <>{children}</>;
}
